import packageJson from "../../package.json";

export default {
  sentry: {
    dsn: "https://3bff4a2152514ab6aaeaade88e32baee@sentry.io/6260989"
  },
  player: {
    timeToHideUI: 3000,
    timeToShowPauseScreen: 7000,
    nextEpisodeCountDown: 15,
    loadTimeout: 60000,
    bufferingTimeout: 60000,
    playbackPercentages: [0, 0.25, 0.5, 0.75, 0.9],
    playbackRates: {
      1: 500,
      2: 250,
      3: 125
    },
    streamingTechnology: "hss",
    drmTechnology: "playready",
    skipOutroCountDown: 5
  },
  featureToggles: {
    maxDevices: true,
    filmstrip: true,
    eVoucher: false,
    analytics: true,
    playbackAnalytics: {
      trailerFixedDuration: 120
    },
    exitAppPopup: false,
    backToTop: false,
    remoteLocales: false,
    skipIntro: false,
    skipOutro: false
  },
  layouts: {
    modulesPageSize: 7
  },
  search: {
    delay: 1500,
    queryMinCharacters: {
      default: 1 // The search minimum characters limit could be added by the languages [en, ar, fr]
    }
  },
  minPassLength: 6,
  authenticationKey: "STARZPLAYappSECRET", // Besides, find a better way to protect the user data.
  mediaListPageSize: 50,
  locales: {
    en: {
      direction: "ltr",
      separator: ","
    },
    ar: {
      direction: "rtl",
      separator: "،"
    },
    fr: {
      direction: "ltr",
      separator: ","
    }
  },
  sdk: {
    defaultLocale: "en",
    networkRequestsTimeout: 60000,
    supportedLanguages: ["en", "fr", "ar", "hi", "ur", "ta", "ml", "te", "pa", "mr", "bn", "bho", "gu", "kn"],
    backendHosts: {
      auth: "https://app-api.starzplay.com/api/auth",
      media: "https://app-api.starzplay.com/api/media",
      settings: "https://app-api.starzplay.com/api/settings",
      reports: "https://app-api.starzplay.com/api/reports",
      payments: "https://app-api.starzplay.com/api/payments"
    },
    localCache: {
      auth: true,
      layouts: false,
      titles: false,
      search: true,
      feeds: false,
      genres: true,
      devices: true,
      preferences: true,
      memoryCache: true,
      paymentMethodDictionary:true
    },
    shuffleLayoutStaticModules: false,
    layoutCacheTime: 21600000, // 6 hours
    titlesCacheTime: 10800000,
    seasonsCacheTime: 7200000,
    heartbeatPeriod: 25000,
    episodesCacheTime: 300000,
    genresCacheTime: 172800000,
    feedsCacheTime: 7200000,
    devicesCacheTime: 3600000,
    userPreferencesCacheTime: 900000,
    memoryCacheLimit: 5242880,
    minimumCacheCleanupTime: 300000,
    tokenExpirationTime: 10000 * 365 * 24 * 60 * 60,
    filmstripsTimeJump: 10000,
    drmTechnology: "playready",
    drmLicenseServer: "http://playready-license.drm.technology/rightsmanager.asmx",
    platformName: "smarttv",
    maxUserDevices: 5,
    imageWidths: {
      hero: 900,
      heroMain: 557,
      poster: 147,
      screenshot: 296
    },
    appVersion: packageJson.version,
    publicVersion: "4.0.0", // This version is for use by teams other than dev
    appName: "Playstation",
    clientType: "sony-ps4",
    deviceName: "PlayStation®4",
    deviceType: "playstation4",
    initialBitrateHD: 650000,
    initialBitrate4K: 850000,
    initialBitrateTrailer: 1700000,
    maxBitrate: 4700000,
    playbackAnalytics: {
      accountCode: "parsifalentertainment",
      enableAnalytics: true,
      httpSecure: true,
      libSrc: "https://smartplugin.youbora.com/v6/js/adapters/pswebmaf/6.4.4/sp.min.js"
    },
    // analyticsId: "UA-52364929-21" // NOTE: Current analyticsId is the one used for DEVELOPMENT purposes. The one to be used for PRODUCTION is "UA-52364929-33".
    analyticsId: "G-PSL99VZEE9"
  },
  settingsSubsections: [
    {
      name: "profile",
      onlyLoggedIn: true,
      minimumParentalLevel: "1"
    },
    // {
    //   name: "subscriptions",
    //   onlyLoggedIn: true,
    //   minimumParentalLevel: "1"
    // },
    {
      name: "language",
      onlyLoggedIn: false,
      minimumParentalLevel: "1"
    },
    {
      name: "parentalControl",
      onlyLoggedIn: true,
      minimumParentalLevel: "1"
    },
    {
      name: "accountStatus",
      onlyLoggedIn: true,
      minimumParentalLevel: "18"
    },
    {
      name: "devices",
      onlyLoggedIn: true,
      minimumParentalLevel: "18"
    },
    {
      name: "history",
      onlyLoggedIn: true,
      minimumParentalLevel: "18"
    },
    {
      name: "help",
      onlyLoggedIn: false,
      minimumParentalLevel: "1"
    },
    // {
    //   name: "contactUs",
    //   onlyLoggedIn: false,
    //   minimumParentalLevel: "1"
    // },
    {
      name: "eVoucher",
      onlyLoggedIn: false,
      minimumParentalLevel: "1"
    },
    {
      name: "logout",
      onlyLoggedIn: true,
      minimumParentalLevel: "1"
    }
    // {
    //   name: "exit",
    //   onlyLoggedIn: false,
    //   minimumParentalLevel: "1"
    // }
  ],
  parentalControlList: ["1", "7", "15", "18"],
  limitedAppAccessParentalLevel: 1,
  unlimitedAppAccessParentalLevel: 18,
  allowedCountries: [
    { code: "DZ" },
    { code: "BH" },
    { code: "DJ" },
    { code: "EG" },
    { code: "IQ" },
    { code: "JO" },
    { code: "KW" },
    { code: "LB" },
    { code: "LY" },
    { code: "MR" },
    { code: "MA" },
    { code: "OM" },
    { code: "PS" },
    { code: "QA" },
    { code: "SA" },
    { code: "SS" },
    { code: "TN" },
    { code: "AE" },
    { code: "YE" },
    { code: "IN" },
    { code: "KR" },
    { code: "ES" },
    { code: "PK" }
  ],
  geoblockingTimeout: 20000,
  defaultGenresMenuItems: [
    {
      name: "lastAdded",
      sort: "lastAdded"
    },
    {
      name: "alphabetical",
      sort: "alphabetical"
    }
  ],
  ui: {
    urlCdn: "http://mena-img-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images",
    animations: false,
    throttle: {
      high: 75,
      medium: 150,
      low: 300
    }
  },
  debug: {
    enabled: false,
    overlay: {
      height: "100%",
      lines: 40,
      opacity: 0.6
    }
  },
  unmanagedPaymentPlans: ["cedarcom_lb", "ooredooTv_qa", "ooredooApp_qa", "apple_iap", "anghami_lb"],
  buyAssetOrBrand: {
    pollingTime: 30000
  },
  rentDisclaimerTime: {
    hours: 48,
    days: 30
  },
  isContentTypeTVOD: false,
  isContentTypeSVOD: false,
  expiryTimeInDays: 14,
  isExpiryTimeShown: false
};
